// LISTAS DE DADOS MESTRES (VERSÃO FLAT COMPATÍVEL V7.2)

export const BRAZIL_STATES = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

// DICIONARIO UF -> NOME POR EXTENSO (qualificacao forense)
export const UF_TO_NAME = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

// DICIONARIO DE PREPOSICOES POR UF
export const UF_PREPOSITION = {
  AC: "do",
  AL: "de",
  AP: "do",
  AM: "do",
  BA: "da",
  CE: "do",
  DF: "do",
  ES: "do",
  GO: "de",
  MA: "do",
  MT: "de",
  MS: "de",
  MG: "de",
  PA: "do",
  PB: "da",
  PR: "do",
  PE: "de",
  PI: "do",
  RJ: "do",
  RN: "do",
  RS: "do",
  RO: "do",
  RR: "de",
  SC: "de",
  SP: "de",
  SE: "de",
  TO: "do",
};

export const GENDER_IDENTITIES = [
  "Cisgênero (Identifica-se com o sexo biológico)",
  "Transgênero",
  "Não-Binário",
  "Travesti",
  "Outro / Prefiro não informar",
];

export const GRAMMATICAL_GENDERS = [
  { value: "M", label: "Masculino (O Contratante / O Autor)" },
  { value: "F", label: "Feminino (A Contratante / A Autora)" },
  { value: "N", label: "Neutro/Inclusivo (A Parte Contratante)" },
];

export const NATIONALITIES = [
  "Brasileiro(a)",
  "Português(a)",
  "Alemão(ã)",
  "Angolano(a)",
  "Argentino(a)",
  "Boliviano(a)",
  "Chileno(a)",
  "Chinês(a)",
  "Colombiano(a)",
  "Cubano(a)",
  "Espanhol(a)",
  "Francês(a)",
  "Haitiano(a)",
  "Italiano(a)",
  "Japonês(a)",
  "Norte-Americano(a)",
  "Paraguaio(a)",
  "Peruano(a)",
  "Uruguaio(a)",
  "Venezuelano(a)",
];

export const CIVIL_STATUS = [
  "Casado(a)",
  "Divorciado(a)",
  "Em União Estável",
  "Separado(a) Judicialmente",
  "Solteiro(a)",
  "Viúvo(a)",
];

export const MARITAL_REGIMES_LIST = [
  "Comunhão Parcial de Bens",
  "Comunhão Universal de Bens",
  "Separação Total de Bens",
  "Participação Final nos Aquestos",
  "Separação Obrigatória de Bens",
];

export const ORG_EMISSORES = [
  "SSP (Secretaria de Segurança Pública)",
  "DETRAN",
  "Polícia Federal",
  "OAB",
  "CRM",
  "CREA",
  "Outros",
];

// Órgão expedidor da CIN (Carteira de Identidade Nacional) por UF —
// crescimento orgânico (decisão do titular, 24/08/2026): não existe uma
// lista nacional confiável verificável por pesquisa — buscas retornaram
// atribuições contraditórias entre estados (ex.: "Instituto de
// Identificação Félix Pacheco" apareceu tanto para o Piauí quanto para o
// Rio de Janeiro). Só entra aqui o que foi confirmado por fonte primária
// (o próprio documento de um cliente real). Preencher os demais estados só
// quando surgir um caso real, nunca por achismo — mesmo princípio do
// Art. 19.2 da Constituição de Processos (não presumir organizerState).
export const CIN_ORGAO_EXPEDIDOR_POR_UF = {
  PR: "Instituto de Identificação do Paraná", // confirmado: CIN da cliente [CLIENTE_A], 24/08/2026
};

export const PROFESSIONAL_COUNCILS = [
  "OAB (Advocacia)",
  "CRM (Medicina)",
  "CREA (Engenharia/Agronomia)",
  "CAU (Arquitetura)",
  "CRO (Odontologia)",
  "COREN (Enfermagem)",
  "CRMV (Veterinária/Zootecnia)",
  "CRC (Contabilidade)",
  "CRA (Administração)",
  "CRECI (Corretores de Imóveis)",
  "CRF (Farmácia)",
  "CREF (Educação Física)",
  "CREFITO (Fisioterapia)",
];

export const PROFESSIONS = [
  "Administrador(a)",
  "Advogado(a)",
  "Agricultor(a)",
  "Analista de Sistemas",
  "Aposentado(a)",
  "Arquiteto(a)",
  "Autônomo(a)",
  "Bancário(a)",
  "Comerciante",
  "Contador(a)",
  "Corretor(a) de Imoveis",
  "Dentista",
  "Empresário(a)",
  "Enfermeiro(a)",
  "Engenheiro(a)",
  "Estudante",
  "Farmacêutico(a)",
  "Funcionário(a) Público(a)",
  "Médico(a)",
  "Motorista",
  "Policial",
  "Profissional de Educação Física",
  "Professor(a)",
  "Fisioterapeuta",
  "Terapeuta Ocupacional",
  "Veterinário(a)",
];

export const PJ_ROLES = [
  "Sócio-Administrador",
  "Administrador (Não Sócio)",
  "Diretor",
  "Presidente",
  "Procurador",
  "Síndico",
];

export const ANIMAL_SPECIES = [
  "Canina (Cão)",
  "Felina (Gato)",
  "Ave",
  "Equina",
  "Outro",
];

export const ANIMAL_REPRODUCTIVE_STATUS = [
  "Inteiro (Não Castrado)",
  "Castrado (Orquiectomia/Ovariohisterectomia)",
  "Esterilizado/Vasectomizado",
  "Não Informado",
];

export const ANIMAL_COAT_COLORS = [
  "Preto",
  "Branco",
  "Marrom/Chocolate",
  "Cinza/Azul",
  "Dourado/Amarelo",
  "Creme/Fawn",
  "Ruivo/Alazão",
  "Misto/Multicolor",
  "Outro",
];

export const ANIMAL_COAT_PATTERNS = [
  "Sólido (Sem marcações)",
  "Bicolor",
  "Tricolor",
  "Tabby/Tigrado (Mackerel)",
  "Tabby Clássico (Blotched)",
  "Tortoiseshell (Escama)",
  "Calico",
  "Merle",
  "Brindle (Tigrado Canino)",
  "Ruão",
  "Pampa/Tobiano (Equino)",
  "Outro",
];

export const ANIMAL_COAT_TEXTURES = [
  "Curto/Liso",
  "Longo",
  "Duro/Arame",
  "Crespo/Encaracolado",
  "Hairless (Sem pelo)",
];

export const ANIMAL_BREEDS = [
  "SRD (Sem Raça Definida)",
  "Poodle",
  "Shih Tzu",
  "Pastor Alemão",
  "Outra",
];

export const ANIMAL_ROLES = [
  "Responsável Legal",
  "Tutor(a) / Guardião(ã)",
  "Fiel Depositário(a)",
];

export const INCAPACITY_REASONS = [
  "Menor Impúbere (< 16 anos)",
  "Menor Púbere (16-18 anos)",
  "Enfermidade Grave",
  "Interdição Judicial",
];

export const REPRESENTATION_TYPE = [
  "Assistido(a) por",
  "Representado(a) por",
  "Curatelado(a) por",
  "Tutelado(a) por",
];

export const PRISON_RELATION = [
  "Advogado(a)",
  "Cônjuge",
  "Mãe / Pai",
  "Filho(a)",
  "Irmão / Irmã",
];

export const HEALTH_CONDITIONS = [
  "NENHUMA",
  "DOENCA_GRAVE",
  "DEFICIENCIA_FISICA",
  "DEFICIENCIA_MENTAL",
  "AUTISMO",
  "IDOSO",
  "SUPER_IDOSO",
];

export const HEALTH_LABELS = {
  NENHUMA: "Nenhuma condição especial",
  DOENCA_GRAVE: "Doença Grave (Prioridade Legal - Art. 1.048 CPC)",
  DEFICIENCIA_FISICA: "PcD (Física)",
  DEFICIENCIA_MENTAL: "PcD (Mental/Intelectual)",
  AUTISMO: "PcD (Espectro Autista - TEA)",
  IDOSO: "Idoso (60+)",
  SUPER_IDOSO: "Super Idoso (80+)",
};

export const PRONOUNS = ["ELE", "ELA", "ELU"];

export const CLIENT_ORIGIN = [
  { value: "INDICACAO", label: "Indicação" },
  { value: "SITE", label: "Site (Portal)" },
  { value: "REDES_SOCIAIS", label: "Redes Sociais" },
  { value: "EVENTO", label: "Evento/Palestra" },
  { value: "GOOGLE", label: "Google/Busca Orgânica" },
  { value: "ADVBOX", label: "AdvBox/Plataforma" },
  { value: "JURE", label: "Jure/Plataforma" },
  { value: "INDICACAO_ADV", label: "Indicação de Advogado(a)" },
  { value: "RECONVENCAO", label: "Reconvenção (era parte adversa)" },
  { value: "OUTRO", label: "Outro" },
];

// DICIONARIO DE CONSELHOS PROFISSIONAIS PARA QUALIFICACAO FORENSE
const ufName = (sigla) => UF_TO_NAME[sigla] || sigla;

const ufPrep = (sigla) => UF_PREPOSITION[sigla] || "de";

const inflectInscrito = (gender) => {
  const g = String(gender || "")
    .trim()
    .toUpperCase();
  return g === "F" ? "inscrita" : "inscrito";
};

export const REGISTER_PROVIDERS = {
  OAB: {
    sigla: "OAB",
    extenso: "Ordem dos Advogados do Brasil",
    orgaoFederal: "CFOAB",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} na Ordem dos Advogados do Brasil, Seccional ${ufPrep(uf)} ${ufName(uf)} (OAB/${uf}) sob o n. ${numero}`,
  },
  CRM: {
    sigla: "CRM",
    extenso: "Conselho Regional de Medicina",
    orgaoFederal: "CFM",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Medicina ${ufPrep(uf)} ${ufName(uf)} (CRM/${uf}) sob o n. ${numero}`,
  },
  CREA: {
    sigla: "CREA",
    extenso: "Conselho Regional de Engenharia e Agronomia",
    orgaoFederal: "CONFEA",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Engenharia e Agronomia ${ufPrep(uf)} ${ufName(uf)} (CREA/${uf}) sob o n. ${numero}`,
  },
  CAU: {
    sigla: "CAU",
    extenso: "Conselho de Arquitetura e Urbanismo",
    orgaoFederal: "CAU/BR",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho de Arquitetura e Urbanismo ${ufPrep(uf)} ${ufName(uf)} (CAU/${uf}) sob o n. ${numero}`,
  },
  CRO: {
    sigla: "CRO",
    extenso: "Conselho Regional de Odontologia",
    orgaoFederal: "CFO",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Odontologia ${ufPrep(uf)} ${ufName(uf)} (CRO/${uf}) sob o n. ${numero}`,
  },
  COREN: {
    sigla: "COREN",
    extenso: "Conselho Regional de Enfermagem",
    orgaoFederal: "COFEN",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Enfermagem ${ufPrep(uf)} ${ufName(uf)} (COREN/${uf}) sob o n. ${numero}`,
  },
  CRMV: {
    sigla: "CRMV",
    extenso: "Conselho Regional de Medicina Veterinária",
    orgaoFederal: "CFMV",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Medicina Veterinária ${ufPrep(uf)} ${ufName(uf)} (CRMV/${uf}) sob o n. ${numero}`,
  },
  CRC: {
    sigla: "CRC",
    extenso: "Conselho Regional de Contabilidade",
    orgaoFederal: "CFC",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Contabilidade ${ufPrep(uf)} ${ufName(uf)} (CRC/${uf}) sob o n. ${numero}`,
  },
  CRA: {
    sigla: "CRA",
    extenso: "Conselho Regional de Administração",
    orgaoFederal: "CFA",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Administração ${ufPrep(uf)} ${ufName(uf)} (CRA/${uf}) sob o n. ${numero}`,
  },
  CRECI: {
    sigla: "CRECI",
    extenso: "Conselho Regional de Corretores de Imóveis",
    orgaoFederal: "COFECI",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Corretores de Imóveis ${ufPrep(uf)} ${ufName(uf)} (CRECI/${uf}) sob o n. ${numero}`,
  },
  CRF: {
    sigla: "CRF",
    extenso: "Conselho Regional de Farmácia",
    orgaoFederal: "CFF",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Farmácia ${ufPrep(uf)} ${ufName(uf)} (CRF/${uf}) sob o n. ${numero}`,
  },
  CREF: {
    sigla: "CREF",
    extenso: "Conselho Regional de Educação Física",
    orgaoFederal: "CONFEF",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Educação Física ${ufPrep(uf)} ${ufName(uf)} (CREF/${uf}) sob o n. ${numero}`,
  },
  CREFITO: {
    sigla: "CREFITO",
    extenso: "Conselho Regional de Fisioterapia e Terapia Ocupacional",
    orgaoFederal: "COFFITO",
    buildText: (numero, uf, gender) =>
      `${inflectInscrito(gender)} no Conselho Regional de Fisioterapia e Terapia Ocupacional ${ufPrep(uf)} ${ufName(uf)} (CREFITO/${uf}) sob o n. ${numero}`,
  },
};

// Lista expandida de profissoes com mapeamento opcional para conselho padrao
export const PROFESSIONS_WITH_COUNCIL = {
  "Administrador(a)": "CRA",
  "Advogado(a)": "OAB",
  "Agricultor(a)": null,
  "Analista de Sistemas": null,
  "Aposentado(a)": null,
  "Arquiteto(a)": "CAU",
  "Autônomo(a)": null,
  "Bancário(a)": null,
  Comerciante: null,
  "Contador(a)": "CRC",
  "Corretor(a) de Imoveis": "CRECI",
  Dentista: "CRO",
  "Empresário(a)": null,
  "Enfermeiro(a)": "COREN",
  "Engenheiro(a)": "CREA",
  Estudante: null,
  "Farmacêutico(a)": "CRF",
  "Funcionário(a) Público(a)": null,
  "Médico(a)": "CRM",
  Motorista: null,
  Policial: null,
  "Profissional de Educação Física": "CREF",
  "Professor(a)": null,
  Fisioterapeuta: "CREFITO",
  "Terapeuta Ocupacional": "CREFITO",
  "Veterinário(a)": "CRMV",
};

export const CLIENT_TAGS = [
  { value: "URGENTE", label: "Urgente", color: "red" },
  { value: "PROBONO", label: "Pro Bono", color: "green" },
  { value: "ALTA_RENDA", label: "Alta Renda", color: "gold" },
  { value: "CONTENCIOSO", label: "Contencioso", color: "blue" },
  { value: "CONSULTIVO", label: "Consultivo", color: "purple" },
  { value: "RECORRENTE", label: "Recorrente", color: "teal" },
  { value: "EXIGENTE", label: "Exigente", color: "orange" },
  { value: "VULNERAVEL", label: "Vulnerável", color: "pink" },
  { value: "PRAZO_CURTO", label: "Prazo Curto", color: "amber" },
  { value: "SIGILOSO", label: "Sigiloso", color: "slate" },
];

export const CLIENT_TAG_COLORS = {
  red: "bg-red-100 text-red-700 border-red-300",
  green: "bg-emerald-100 text-emerald-700 border-emerald-300",
  gold: "bg-amber-100 text-amber-700 border-amber-300",
  blue: "bg-blue-100 text-blue-700 border-blue-300",
  purple: "bg-purple-100 text-purple-700 border-purple-300",
  teal: "bg-teal-100 text-teal-700 border-teal-300",
  orange: "bg-orange-100 text-orange-700 border-orange-300",
  pink: "bg-pink-100 text-pink-700 border-pink-300",
  amber: "bg-amber-100 text-amber-700 border-amber-300",
  slate: "bg-slate-100 text-slate-700 border-slate-300",
};
